/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { amount } from '../../ehr/subs/amount';
import { condition } from '../../ehr/subs/condition';
import { diagnosisreference } from '../../ehr/subs/diagnosisreference';
import { referenceidentification } from '../../ehr/subs/referenceidentification';
import { referralreference } from '../../ehr/subs/referralreference';
import { servicedate } from '../../ehr/subs/servicedate';
import { servicereference } from '../../ehr/subs/servicereference';
import { subscriberreference } from '../../ehr/subs/subscriberreference';
import { IceTypes } from "../../icetypes";
import { messagereference } from '../../messages/messagereference';
import { medicalservice } from '../medservice/medicalservice';
import { claimambulance } from './claimambulance';
import { claimcontract } from './claimcontract';
import { claimhealthcaredelivery } from './claimhealthcaredelivery';
import { claimhomehealthcareplan } from './claimhomehealthcareplan';
import { claimmedicareoutpatientadjudication } from './claimmedicareoutpatientadjudication';
import { claimnote } from './claimnote';
import { claimrepriced } from './claimrepriced';
import { claimspinal } from './claimspinal';
import { claimsupplementalinformation } from './claimsupplementalinformation';

export class claim extends medicalservice {
  claim_key: string = "";
  claim_date: any = NaN;
  claim_adjudication_date: any = NaN;
  patient_responsibility_amount: number = 0.0;
  last_message_key: string = "";
  last_message_date: any = NaN;
  last_message_log: string = "";
  last_message_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  last_response_message_key: string = "";
  last_response_message_date: any = NaN;
  last_response_message_log: string = "";
  last_response_message_status: IceTypes.trans_status = IceTypes.trans_status.isNone;

  SERVICES: servicereference[] = [];
  AMBS: claimambulance[] = [];
  CNTRCS: claimcontract[] = [];
  HCDELRY: claimhealthcaredelivery[] = [];
  HMPLAN: claimhomehealthcareplan[] = [];
  CLMNOTES: claimnote[] = [];
  REPRICED: claimrepriced[] = [];
  SPNL: claimspinal[] = [];
  SUPPL: claimsupplementalinformation[] = [];
  MCADJUDS: claimmedicareoutpatientadjudication[] = [];
  CONDS: condition[] = [];
  DIAGS: diagnosisreference[] = [];
  COBS: amount[] = [];
  SUBS: subscriberreference[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "SVCDTS") return true;
    else if (ColumnName == "SERVICES") return true;
    else if (ColumnName == "AMBS") return true;
    else if (ColumnName == "CNTRCS") return true;
    else if (ColumnName == "HCDELRY") return true;
    else if (ColumnName == "HMPLAN") return true;
    else if (ColumnName == "CLMNOTES") return true;
    else if (ColumnName == "REPRICED") return true;
    else if (ColumnName == "SPNL") return true;
    else if (ColumnName == "SUPPL") return true;
    else if (ColumnName == "MCADJUDS") return true;
    else if (ColumnName == "REFLREFS") return true;
    else if (ColumnName == "CONDS") return true;
    else if (ColumnName == "DIAGS") return true;
    else if (ColumnName == "COBS") return true;
    else if (ColumnName == "REFIDS") return true;
    else if (ColumnName == "SUBS") return true;
    else if (ColumnName == "MSGS") return true;
    else if (ColumnName == "PROS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "SVCDTS") return "SERVICE_DATE";
    else if (ColumnName == "SERVICES") return "SERVICE_REFERENCE";
    else if (ColumnName == "AMBS") return "CLAIM_AMBULANCE";
    else if (ColumnName == "CNTRCS") return "CLAIM_CONTRACT";
    else if (ColumnName == "HCDELRY") return "CLAIM_HEALTHCARE_DELIVERY";
    else if (ColumnName == "HMPLAN") return "CLAIM_HOME_HEALTH_CARE_PLAN";
    else if (ColumnName == "CLMNOTES") return "CLAIM_NOTE";
    else if (ColumnName == "REPRICED") return "CLAIM_REPRICED";
    else if (ColumnName == "SPNL") return "CLAIM_SPINAL";
    else if (ColumnName == "SUPPL") return "CLAIM_SUPPLEMENTAL_INFORMATION";
    else if (ColumnName == "MCADJUDS") return "CLAIM_MEDICARE_OUTPATIENT_ADJUDICATION";
    else if (ColumnName == "REFLREFS") return "REFERRAL_REFERENCE";
    else if (ColumnName == "CONDS") return "CONDITION";
    else if (ColumnName == "DIAGS") return "DIAGNOSIS_REFERENCE";
    else if (ColumnName == "COBS") return "AMOUNT";
    else if (ColumnName == "REFIDS") return "REFERENCE_IDENTIFICATION";
    else if (ColumnName == "SUBS") return "SUBSCRIBER_REFERENCE";
    else if (ColumnName == "MSGS") return "MESSAGE_REFERENCE";
    else if (ColumnName == "PROS") return "PROVIDER_REFERENCE";

    return null;
  }
}
